import cx from 'classnames';
import { memo, useCallback } from 'react';
import { ButtonIcon } from '@wg/wows-react-uikit';

import { isInGame } from '~/constants';
import dwhExport, { DWH_EVENTS } from '~/dwhExport';
import { showClansInformerDialog } from '~/helpers/dialogs';
import { t } from '~/helpers/localization';
import { useAppDispatch } from '~/store';

import { TooltipBody } from '~/UIKit/components';

import styles from './ClansInformerButton.scss';

import type { ENTRY_SOURCE } from '~/store/slices/settingsSlice';

interface ClansInformerButtonProps {
  clanId?: number;
  source: ENTRY_SOURCE;
}

const ClansInformerButton = ({ clanId, source }: ClansInformerButtonProps) => {
  const dispatch = useAppDispatch();

  const onClick = useCallback(() => {
    dwhExport.push(DWH_EVENTS.SUPPLY.CLANINFO_CLICK);
    dispatch(showClansInformerDialog(clanId, source));
  }, [clanId, dispatch, source]);

  return (
    <div
      className={cx(styles.container, {
        [styles.inGame]: isInGame,
      })}
    >
      <ButtonIcon isFlat type={'info'} onClick={onClick} tooltipContent={<TooltipBody>{t('Clan info')}</TooltipBody>} />
    </div>
  );
};

export default memo(ClansInformerButton);
